// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-list-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
}
.profile-list-panel .panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.profile-list-panel .panel-header h3 {
  margin: 0;
}
.profile-list-panel .profiles-table {
  width: 100%;
  cursor: pointer;
}
.profile-list-panel .profiles-table th.mat-mdc-header-cell {
  font-weight: 600;
}
.profile-list-panel .profiles-table td.mat-mdc-cell,
.profile-list-panel .profiles-table th.mat-mdc-header-cell {
  padding: 0 12px;
}
.profile-list-panel .profiles-table .selected-row {
  background-color: var(--p-primary-100, #e3f2fd);
  font-weight: 500;
}
.profile-list-panel .profiles-table tr.mat-mdc-row:hover {
  background-color: var(--p-surface-100, #f5f5f5);
}
.profile-list-panel .empty-message {
  color: var(--p-text-muted-color, #888);
  padding: 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/pycnometer-profiles/pycnometer-profile-list/pycnometer-profile-list.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACE,SAAA;AACN;AAGE;EACE,WAAA;EACA,eAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;;EAEE,eAAA;AAFN;AAKI;EACE,+CAAA;EACA,gBAAA;AAHN;AAMI;EACE,+CAAA;AAJN;AAQE;EACE,sCAAA;EACA,eAAA;AANJ","sourcesContent":[".profile-list-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 1rem;\n\n  .panel-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n\n    h3 {\n      margin: 0;\n    }\n  }\n\n  .profiles-table {\n    width: 100%;\n    cursor: pointer;\n\n    th.mat-mdc-header-cell {\n      font-weight: 600;\n    }\n\n    td.mat-mdc-cell,\n    th.mat-mdc-header-cell {\n      padding: 0 12px;\n    }\n\n    .selected-row {\n      background-color: var(--p-primary-100, #e3f2fd);\n      font-weight: 500;\n    }\n\n    tr.mat-mdc-row:hover {\n      background-color: var(--p-surface-100, #f5f5f5);\n    }\n  }\n\n  .empty-message {\n    color: var(--p-text-muted-color, #888);\n    padding: 16px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
